import React from "react";
import type { FC, ComponentProps } from "react";

import { Indicator } from "../../../../Indicator";

import type { OmitOfUnion } from "../../../../../types/react";
import type { IndicatorProps } from "../../../../Indicator";

type IButtonTopRightIndicatorProps = OmitOfUnion<IndicatorProps, "size">;

const BUTTON_TOP_RIGHT_INDICATOR_DISPLAY_NAME = "Button.TopRightIndicator";

const ButtonTopRightIndicator: FC<IButtonTopRightIndicatorProps> = ({
    view,
    customColorsStyles,
    ...restProps
}) => {
    const indicatorProps: ComponentProps<typeof Indicator> = {
        ...restProps,
        ...(view === "custom"
            ? { view: "custom", customColorsStyles: customColorsStyles || "" }
            : { view }),
    };

    return (
        <Indicator data-tsid="button-top-right-indicator" {...indicatorProps} />
    );
};

ButtonTopRightIndicator.displayName = BUTTON_TOP_RIGHT_INDICATOR_DISPLAY_NAME;

export default ButtonTopRightIndicator;
